import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
import { AxiosPromise } from 'axios';

const rootPath = 'Entreprises';


class SitesServices {
    public getTableUrl(lang:string): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}${buildQuery({lang})}`;
    }

    public getByIdAndLanguage(id: string, lang:string): Promise<any> {
        return apiClient.get(`${rootPath}/GetByIdAndLanguage/${id}${buildQuery({lang})}`);
    }

    public getTableUrlByAdministrator(lang:string): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}/GetByAdministrator${buildQuery({lang})}`;
    }

    public async getEntreprises(lang:string): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({lang})}`);
    }

    public async getEntreprisesBySite(lang:string,siteId:string): Promise<any> {
        return apiClient.get(`${rootPath}/bysite${buildQuery({lang,siteId})}`);
    }

    public addEntreprise(data: any,lang:string): AxiosPromise {
        return apiClient.put(`${rootPath}/${data.entreprise.id}${buildQuery({lang})}`, data);
    }
}

export default new SitesServices();